export const currencySigns = {
    EUR: '€',
    USD: '$',
    // GBP: '£',
    // JPY: '¥',
    // AUD: 'A$',
    // CAD: 'C$',
    // CHF: 'CHF',
    // CNY: '¥',
    // SEK: 'kr',
    // NZD: 'NZ$',
};